import 'client-only';

import { type Brand } from '@/consts/brands';
import { get } from '@/utils/http/client';
import { urls } from '@/utils/urls';

import { type ProviderData } from './types';

const getProviderInformation = (brand: Brand) =>
  get<{ data: ProviderData }>(urls[brand].api.liveConsultations.provider);

export const LiveConsultationService = {
  getProviderInformation,
};
